import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-publish-success-modal',
    templateUrl: './publish-success-modal.component.html',
    styleUrls: ['./publish-success-modal.component.scss']
})
export class PublishSuccessModalComponent implements OnInit {
    public constructor() {}

    ngOnInit(): void {}
}
